function eye_toggle() {
  var password = $('#password')[0];
  if (password.type === "password") {
    password.type = "text";
    $('#eye_btn').css('background-image', 'url("   //gomimall.vn/cdn/shop/t/18/assets/eye.png?v=37641924019604533171751856981 ")');
  } else {
    password.type = "password";
    $('#eye_btn').css('background-image', 'url("   //gomimall.vn/cdn/shop/t/18/assets/eye-slash.png?v=8509275132159436421751856981 ")');
  }
}